//@ts-check
import QRCodeCard from "../../../utils/QrCodeCard";
import numberWithCommas from "../../../utils/numbersWithComma";
import { APP_CONST } from "../../../config/const";
import { AiFillCopy } from "react-icons/ai";
import { Toaster } from "../../../utils/toaster";

const FORMAT_TYPES = {
  text: "string",
  number: "number",
  qrCodeValue: "qrcode",
  image: "image",
};

const handleCopy = async (text) => {
  if (!text) return;
  navigator.clipboard.writeText(text).then(() => {
    Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
  });
};

const RenderValue = ({ item, selectedGateway }) => {
  switch (item?.format) {
    case FORMAT_TYPES.text:
      return (
        <div className="displaying-text-number">
          {selectedGateway === "l5I8Url8" && (
            <div className="displayng-text-2">
              <div className="text-copy-background">
                <div className="value-display-text">{item?.value}</div>
                <div
                  className="copyValue"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    fontSize: "10px",
                  }}
                >
                  <div
                    onClick={() => handleCopy(item?.value)}
                    style={{ cursor: "pointer" }}
                  >
                    {/* Click to copy code */}
                    <AiFillCopy size={22} />
                  </div>
                </div>
              </div>
            </div>
          )}
          {selectedGateway !== "l5I8Url8" && (
            <div className="displayng-text">
              <div className="displaying-label">{`${item?.label}:`}</div>
              <div className="text-copy-background">
                <div className="value-display-text">{item?.value}</div>
                <div
                  className="copyValue"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    fontSize: "10px",
                  }}
                >
                  <div
                    onClick={() => handleCopy(item?.value)}
                    style={{ cursor: "pointer" }}
                  >
                    {/* Click to copy code */}
                    <AiFillCopy size={22} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    case FORMAT_TYPES.number:
      return (
        <div className="displaying-text-number">
          {" "}
          <div className="displaying-label">{`${item?.label} ${
            item?.value && ":"
          }`}</div>
          {item?.value && (
            <div className="displayng-text">
              {numberWithCommas(item?.value)}{" "}
              <div
                className="copyValue"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  fontSize: "10px",
                }}
              >
                <div
                  onClick={() => handleCopy(numberWithCommas(item?.value))}
                  style={{ cursor: "pointer" }}
                >
                  {/* Click to copy code */}
                  <AiFillCopy size={22} />
                </div>
              </div>
            </div>
          )}
        </div>
      );
    case FORMAT_TYPES.qrCodeValue:
      return (
        <div>
          <div className="label">{`${item?.label}`}</div>
          <div className="displaying-qrcode">
            <QRCodeCard text={item?.value} />
          </div>
        </div>
      );
    case FORMAT_TYPES.image:
      return (
        <div>
          <div className="label">{`${item?.label}`}</div>
          <div className="image-container">
            <img className="displayng-img" src={item?.value} />
          </div>
        </div>
      );
    default:
      return (
        <div className="">
          {" "}
          {/* <div className="displaying-label">{`${item?.label}:`}</div> */}
          <div className="displayng-text">{item?.value}</div>
        </div>
      );
  }
};

const DisplayValues = ({ displayItems = [], selectedGateway = "" }) => {
  return (
    <>
      {displayItems.length > 0 && (
        <div className={`display-values-section`}>
          {displayItems?.map((item, idx) => (
            <div key={idx} className="item">
              {/* <div className="displaying-label">{`${item?.label}:`}</div> */}
              <RenderValue item={item} selectedGateway={selectedGateway} />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DisplayValues;
